var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "card-columns cols-2"
  }, [_c('b-card', {
    attrs: {
      "header": "Line Chart"
    }
  }, [_c('div', {
    staticClass: "chart-wrapper"
  }, [_c('line-example')], 1)]), _vm._v(" "), _c('b-card', {
    attrs: {
      "header": "Bar Chart"
    }
  }, [_c('div', {
    staticClass: "chart-wrapper"
  }, [_c('bar-example')], 1)]), _vm._v(" "), _c('b-card', {
    attrs: {
      "header": "Doughnut Chart"
    }
  }, [_c('div', {
    staticClass: "chart-wrapper"
  }, [_c('doughnut-example')], 1)]), _vm._v(" "), _c('b-card', {
    attrs: {
      "header": "Radar Chart"
    }
  }, [_c('div', {
    staticClass: "chart-wrapper"
  }, [_c('radar-example')], 1)]), _vm._v(" "), _c('b-card', {
    attrs: {
      "header": "Pie Chart"
    }
  }, [_c('div', {
    staticClass: "chart-wrapper"
  }, [_c('pie-example')], 1)]), _vm._v(" "), _c('b-card', {
    attrs: {
      "header": "Polar Area Chart"
    }
  }, [_c('div', {
    staticClass: "chart-wrapper"
  }, [_c('polar-area-example')], 1)])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29ca5fc6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Charts.vue
// module id = 938
// module chunks = 1